import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

interface MessagingInboxIconProps {
  unreadCount: number;
  color: string;
  size: number;
}

const MessagingInboxIcon: React.FC<MessagingInboxIconProps> = ({
  unreadCount,
  color,
  size,
}) => {
  const [displayCount, setDisplayCount] = useState("");
  const [viewSize, setViewSize] = useState(17);

  useEffect(() => {
    if (unreadCount >= 10) {
      setDisplayCount("9+");
      setViewSize(20);
    } else {
      setDisplayCount(unreadCount.toString());
      setViewSize(17);
    }
  }, [unreadCount]);

  const styles = StyleSheet.create({
    unreadText: {
      color: "white",
      fontSize: 12,
      fontWeight: "bold",
    },
    unreadView: {
      alignItems: "center",
      backgroundColor: "red",
      borderRadius: 10,
      height: viewSize,
      justifyContent: "center",
      position: "absolute",
      right: -5,
      top: -5,
      width: viewSize,
    },
  });

  return (
    <View style={{ position: "relative" }}>
      <Ionicons name="chatbubbles-outline" size={size} color={color} />
      {unreadCount > 0 && (
        <View style={styles.unreadView}>
          <Text style={styles.unreadText}>{displayCount}</Text>
        </View>
      )}
    </View>
  );
};

export default MessagingInboxIcon;
